import { useTranslation } from 'react-i18next';
import { Typography, Box, Divider } from '@mui/material';

export const FeatureHeader = () => {
  const { t } = useTranslation();
  return (
    <Box mb={3}>
      <Typography variant="h5" align="center">
        {t('features.title')}
      </Typography>
      <Typography variant="body2" align="center" sx={{ mb: 2 }}>
        {t('features.subtitle')}
      </Typography>
      <Divider />
    </Box>
  );
};

export default FeatureHeader;
